import React, { useMemo } from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { useTheme } from './ThemeContext'
import { createAppTheme } from './createAppTheme'

/**
 * Theme Provider Wrapper
 * Wraps MUI ThemeProvider and applies the current theme
 */
export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme: themeMode } = useTheme()

  // Memoize theme creation to prevent unnecessary recalculations
  const theme = useMemo(() => createAppTheme(themeMode), [themeMode])

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}

export default ThemeProviderWrapper
